module.exports = __webpack_public_path__ + "static/img/offline.b23d5217.png";